import { render } from "./Terms.vue?vue&type=template&id=1f46bfc4&scoped=true&ts=true"
import script from "./Terms.vue?vue&type=script&lang=ts"
export * from "./Terms.vue?vue&type=script&lang=ts"

import "./Terms.vue?vue&type=style&index=0&id=1f46bfc4&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f46bfc4"]])

export default __exports__